module.exports = __webpack_public_path__ + "static/media/crdscis.624e9569.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/userarea/crdscis.png
// module id = 177
// module chunks = 0